// extracted by mini-css-extract-plugin
export default {"findArtistText":"X6JMFD9sTsoMw2DgQEtZ"};